module.exports = __webpack_public_path__ + "img/newtop.c8f04f5d.webp";